import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

import { formatNumber, persianDigits } from '@/features/reports/lib/format';
import { fa } from '../i18n/fa';
import ChartCard from './ChartCard';
import { ChartLegend, COLORS, rtlXAxisProps, rtlYAxisProps, chartTooltipStyle } from './chartTheme';

export default function PriceLadderChart({ ladder, chain, units }) {
  const perKg = `${fa.unitLabel(units?.price_unit)} / ${fa.unitLabel(units?.quantity_unit)}`;
  const rows = ladder.labels.map((code, i) => {
    const st = chain?.stages.find((s) => s.code === code);
    const own = code === 'end_customer' ? chain?.end_price : st?.verified ? st.price : null;
    return { code, label: fa.stageName(code), average: ladder.average[i], chain: own };
  });
  return (
    <ChartCard
      title={fa.charts.ladder.title}
      note={fa.charts.ladder.note}
      empty={rows.length === 0}
    >
      <ResponsiveContainer>
        <LineChart data={rows} margin={{ top: 8, right: 8, left: 16, bottom: 8 }}>
          <CartesianGrid stroke={COLORS.grid} strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="label" {...rtlXAxisProps} interval={0} angle={-25} textAnchor="end" height={76} />
          <YAxis {...rtlYAxisProps} tickFormatter={(v) => persianDigits(v)} width={64} />
          <Tooltip
            contentStyle={chartTooltipStyle}
            formatter={(value, name) => [`${formatNumber(value)} ${perKg}`, name]}
          />
          <ChartLegend />
          <Line
            dataKey="average"
            name={fa.charts.ladder.avg}
            stroke={COLORS.muted}
            strokeDasharray="5 4"
            connectNulls
          />
          <Line dataKey="chain" name={fa.chain.selectedChain} stroke={COLORS.primary} strokeWidth={2} connectNulls />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
